(() => {
  function connectFeatures(scope) {
    scope.querySelectorAll('[data-nba-product-content]').forEach(root => {
      const description = root.querySelector('.nba-product-description');
      const link = root.querySelector('[data-nba-features-link]');
      if (!description || !link) return;
      const heading = [...description.querySelectorAll('h2,h3,h4,h5,h6')]
        .find(node => /^(key\s+)?features\s*:?$/i.test(node.textContent.trim()));
      if (!heading) return;
      if (!heading.id) heading.id = description.id + '-features';
      link.href = '#' + heading.id;
      link.hidden = false;
    });
  }
  connectFeatures(document);
  document.addEventListener('shopify:section:load', event => connectFeatures(event.target));
})();
